import { render, staticRenderFns } from "./sendMsg.vue?vue&type=template&id=b8d151a4&scoped=true&"
import script from "./sendMsg.vue?vue&type=script&lang=js&"
export * from "./sendMsg.vue?vue&type=script&lang=js&"
import style0 from "./sendMsg.vue?vue&type=style&index=0&id=b8d151a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d151a4",
  null
  
)

export default component.exports